module.exports = __webpack_public_path__ + "a37424fc55077db7c65e7dd735c90ae6.png";